import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import draggable from "vuedraggable";
import settingSlot from "./settingSlot";
import * as shopinfo from '@/api/mall/shopinfo';
import iconSelect from "../pages/page-components/iconSelect.vue";
import MaterialList from '@/components/material/list.vue';
export default {
  components: {
    draggable: draggable,
    settingSlot: settingSlot,
    iconSelect: iconSelect,
    MaterialList: MaterialList
  },
  data: function data() {
    return {
      dialogVisibleGoods: false,
      shopList: [],
      selectionGoodsSpu: [],
      formDataCopy: {
        title: '店铺甄选',
        titleImage: '',
        titleColor: 'red',
        titleIcon: 'cuIcon-shop',
        pageSpacing: 0,
        shopInfoData: [{
          id: '',
          imgUrl: '',
          address: '',
          name: '店铺名'
        }]
      },
      formData: {}
    };
  },
  props: {
    showData: {
      type: Object,
      default: function _default() {}
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpage.componentsList;
    },
    clickComIndex: function clickComIndex(state) {
      return state.divpage.clickComIndex;
    }
  })),
  mounted: function mounted() {
    this.getShopList(); // 加载所有店铺数据
    var that = this;
    if (that.IsEmptyObj(that.showData)) {
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
    } else {
      that.formData = that.showData;
    }
    that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
    // that.updateData({
    //   componentsList: that.componentsList
    // })
  },

  methods: _objectSpread(_objectSpread({
    getShopList: function getShopList() {
      var _this = this;
      //获取所有店铺
      shopinfo.getPage().then(function (response) {
        _this.shopList = response.data.data.records;
      }).catch(function () {});
    },
    onChangeShop: function onChangeShop(value, itemShop) {
      //更改店铺
      if (value) {
        this.shopList.map(function (item) {
          if (item.id == value) {
            itemShop.id = item.id;
            itemShop.name = item.name;
            itemShop.address = item.address;
            itemShop.imgUrl = item.imgUrl;
          }
        });
      } else {
        itemShop.id = '';
        itemShop.name = '';
        itemShop.address = '';
        itemShop.imgUrl = '';
      }
    }
  }, mapMutations(['updateData'])), {}, {
    // 拖动的事件等等=======================================================>
    datadragStart: function datadragStart(e) {
      var that = this;
    },
    datadragUpdate: function datadragUpdate(e) {
      e.preventDefault();
    },
    datadragEnd: function datadragEnd(e) {
      // console.log(e, "拖动结束");
    },
    datadragMove: function datadragMove(e, originalEve) {
      return e.draggedContext.element.text !== 'Gold（不可拖动元素）';
    },
    addItem: function addItem() {
      var that = this;
      that.pushItem();
    },
    pushItem: function pushItem() {
      var that = this;
      if (that.formData.shopInfoData && that.formData.shopInfoData.length >= 10) {
        that.$message.error("项目不能超过10条");
        return false;
      }
      this.formData.shopInfoData.push({
        id: '',
        imgUrl: '',
        address: '',
        name: '店铺名'
      });
    },
    // 删除项目
    delItem: function delItem(index) {
      var that = this;
      if (that.formData.shopInfoData.length <= 1) {
        that.$message.error("请至少保留一条项目");
        return false;
      }
      that.$confirm('是否删除该项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.formData.shopInfoData, index);
      }).catch(function () {});
    },
    // 删除按钮
    delBtn: function delBtn(index) {
      var that = this;
      that.$confirm('是否删除该组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.componentsList[that.clickComIndex].data.itemArray, index);
        that.updateData({
          componentsList: that.componentsList
        });
      }).catch(function () {});
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    reset: function reset() {
      var that = this;
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
      that.componentsList[that.clickComIndex]['data'] = this.formData;
    },
    confirm: function confirm() {
      this.$emit('confirm', this.formData);
    },
    delete: function _delete() {
      this.$emit('delete');
    }
  }),
  watch: {
    showData: {
      handler: function handler(newVal, oldVal) {
        this.formData = newVal ? newVal : this.formData;
      },
      deep: true
    },
    formData: function formData() {}
  }
};